module.exports = __webpack_public_path__ + "img/marketing_es.e1ca87ca.png";